import { Injectable, Optional, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NXIRestServiceDefinition } from './NXI-Rest-service-definition';
import { ServiceRouter } from '@pershing/pershing-core';

@Injectable()
export class QuickQuoteService {

    private modSymbolLookupUrl = '';
    private queryString = '/lookup?symbol=';
    private symbolDataQuery = '/quickquote?symbol=';
    private baseUrl: string;
    constructor(private serviceRouter: ServiceRouter, private http: HttpClient, @Optional() @Inject('AppSettings') appSettings: any) {
        this.modSymbolLookupUrl = appSettings.ibdConfigMap.modApiUrl + '/public';
        this.baseUrl = this.serviceRouter.getServiceRouteURL(NXIRestServiceDefinition.getInstance());
        this.baseUrl += '/portfolio';
    }
    getModSymbolLookupResponse(symbol: string): Observable<any> {
        return this.http.jsonp(this.modSymbolLookupUrl + this.queryString + symbol, 'callback');
    }
    getModSymbolData(symbol: string): Observable<any> {
        return this.http.jsonp(this.modSymbolLookupUrl + this.symbolDataQuery + symbol, 'callback');
    }
    getAgreementDetails(): Observable<any> {
        let timeNow = Date.now();
        return this.http.get(this.baseUrl + '/agree' + '?time=' + timeNow);
    }
    getUserPreference(): Observable<any> {
        let timeNow = Date.now();
        return this.http.get(this.baseUrl + '/getUseRealTimePref' + '?time=' + timeNow);
    }
    setUserPreference(isRealTime: boolean): Observable<any> {
        let timeNow = Date.now();
        return this.http.get(this.baseUrl + '/setUseRealTimePref?pref=' + isRealTime + '?time=' + timeNow);
    }
    getRealTimeKey(symbol: string): Observable<any> {
        let timeNow = Date.now();
        return this.http.get(this.baseUrl + '/' + symbol + '/modquote/R' + '?time=' + timeNow);
    }
    getModSymbolDataRT(data: string): Observable<any> {
        return this.http.jsonp(this.modSymbolLookupUrl + '/quickquote?YYY2340_' + data, 'callback');
    }
    setMarketAlertsAggrement(): Observable<any> {
        let timeNow = Date.now();
        return this.http.get(this.baseUrl + '/market/alerts-agreement?isUpdate=true' + '&time=' + timeNow);
    }
}
